<template>
  <div id="app">
    <nav-menu params="route: route"></nav-menu>
    <main :class="isSignUpPage ? 'signup' : ''">
      <div id="content">
        <router-view v-if="!loading" />
        <loader
          color="rgba(255, 152, 0, 0.75)"
          class="mx-auto my-5"
          v-if="loading"
        />
      </div>
    </main>
    <footer-bar></footer-bar>
  </div>
</template>

<script>
import firebase from "firebase";
import NavMenu from "./components/NavMenu";
import Footer from "./components/Footer";
import Loader from "./components/Loader";

export default {
  components: {
    "nav-menu": NavMenu,
    "footer-bar": Footer,
    loader: Loader
  },
  name: "App",
  data() {
    return {
      loading: true
    };
  },
  computed: {
    isSignUpPage() {
      return this.$route.name === "signup";
    }
  },
  created() {
    firebase.auth().onAuthStateChanged(user => {
      if (user) {
        window.authorized = true;
        window.user = user;
      }
      this.loading = false;
    });
  }
};
</script>

<style lang="scss">
html,
body {
  margin: 0;
  min-width: 100%;
  height: 100%;
  overflow-x: hidden;
}

body {
  background-color: #f5f5f5 !important;
}

#app {
  height: 100%;
}

main {
  min-height: calc(100% - 134px);
}

.signup {
  background: url("assets/board-bread-breakfast_1500x.jpg") no-repeat left
    bottom;
  background-size: cover;
}

#content {
  padding: 10px 8px 8px 8px;
}

.container-fluid {
  margin: 0;
  padding: 0 !important;
}

/* Helpers */

.emphasis {
  font-weight: 500;
}
.vertical-middle {
  margin-top: auto;
  margin-bottom: auto;
}

.btn-outline-success.disabled,
.btn-outline-success:disabled {
  cursor: not-allowed;
  color: #28a745;
  background-color: transparent;
}

.has-error .form-control {
  border-color: #a94442;
}

.has-error .checkbox,
.has-error .checkbox-inline,
.has-error .control-label,
.has-error .help-block,
.has-error .radio,
.has-error .radio-inline,
.has-error.checkbox label,
.has-error.checkbox-inline label,
.has-error.radio label,
.has-error.radio-inline label {
  color: #a94442;
}

.btn-file {
  position: relative;
  overflow: hidden;
  top: 4px;
}

.btn-file input[type="file"] {
  position: absolute;
  top: 0;
  right: 0;
  min-width: 100%;
  min-height: 100%;
  font-size: 100px;
  text-align: right;
  filter: alpha(opacity=0);
  opacity: 0;
  outline: none;
  background: white;
  cursor: inherit;
  display: block;
}

.items {
  max-height: 250px;
  overflow-x: hidden;
  overflow-y: auto;
}

.bootstrap-dialog-header {
  width: 100%;
}

.img-rounded {
  border-radius: 50%;
  object-fit: cover;
  object-position: top;
}
</style>
